module.exports = __webpack_public_path__ + "img/icon-suma.a6f7d5e0.svg";